import {axios} from './api';

export default class CalculationsApi {
  static baseUrl = '/calculations';

  static async saveBorrowerNotes(data, config) {
    return axios.post(`${this.baseUrl}/${data.CalculationId}/notes`, {Notes: data.Notes}, config);
  }

  static async getBorrowerNotes(query, config) {
    return axios.get(`${this.baseUrl}/${query.CalculationId}/notes`, config);
  }

  static async getProductComparison(data, config) {
    return axios.post(`${this.baseUrl}/comparison`, data, config);
  }

  // illustrator : modal email to borrower : email illustrations
  static async saveEmailIllustrations(data, config) {
    const body = {
      ToEmails: data.toEmails,
      CalculationIds: data.calculationIds,
    };

    if (data.attachments?.length) {
      body.Attachments = data.attachments.map((attachment) => ({
        CalculationId: attachment.calculationId,
        Filename: attachment.filename,
        Content: attachment.content,
      }));
    }

    return axios.post(`${this.baseUrl}/share`, body, config);
  }
}
